import Loading from "./Loading.vue"; // 引入组件
const LoadingBean = {};
// 注册
LoadingBean.install = function(Vue) {
  // 生成一个vue的子类（就是这个引入的组件）
  const PreviewConstructor = Vue.extend(Loading);
  // 生成一个该子类的实例
  const instance = new PreviewConstructor();
  // 将这个实例挂载在创建的div上，并将此div加入全局挂载点内部
  instance.$mount(document.createElement("div"));
  document.body.appendChild(instance.$el);
  /**
   * 挂载在vue原型上
   */
  Vue.prototype.$Loading = (bool = false) => {
    instance.isLoading = bool;
  };
};
export default LoadingBean;



// WEBPACK FOOTER //
// ./src/components/loading/loading.js